function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_594",
  "data-name": "Gruppe 594",
  transform: "translate(-1114.556 -410.859)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_304",
  "data-name": "Gruppe 304",
  transform: "translate(1114.556 427.396)",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  id: "Polygon_39",
  "data-name": "Polygon 39",
  d: "M57.631,0l57.631,98.8H0Z",
  transform: "translate(115.263 98.797) rotate(180)",
  opacity: 0.102
}), /*#__PURE__*/React.createElement("path", {
  id: "Polygon_58",
  "data-name": "Polygon 58",
  d: "M28.755,0,57.51,49.165H0Z",
  transform: "translate(57.753 49.632)",
  opacity: 0.197
})), /*#__PURE__*/React.createElement("g", {
  id: "explore",
  transform: "translate(1171.044 410.893)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pfad_1117",
  "data-name": "Pfad 1117",
  d: "M31.521,80.216a2.017,2.017,0,0,1-1.432-.605L16.817,66.338a2.017,2.017,0,0,1-.524-2.017C16.433,63.8,31.44,10.929,85.761,8.064a2.017,2.017,0,0,1,2.017.5,2.158,2.158,0,0,1,.585,1.876C85.579,64.906,32.61,79.934,32.086,80.075A2.562,2.562,0,0,1,31.521,80.216ZM20.528,64.341,32.086,75.9c7.3-2.4,48.612-17.932,52.081-63.639C38.4,15.729,22.908,57.039,20.528,64.341Z",
  transform: "translate(-1.003 -8.01)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_1118",
  "data-name": "Pfad 1118",
  d: "M11.924,46.768a2.019,2.019,0,0,1-2.017-2.259A30.256,30.256,0,0,1,31.228,20.425a2.017,2.017,0,1,1,1.19,3.853A26.222,26.222,0,0,0,14.547,42.189L20.194,41.1a2.051,2.051,0,1,1,.746,4.034l-8.653,1.654A1.31,1.31,0,0,1,11.924,46.768Z",
  transform: "translate(-7.426 4.54)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_1119",
  "data-name": "Pfad 1119",
  d: "M28.587,62.2a2,2,0,0,1-1.977-2.4l1.654-8.653a2.051,2.051,0,1,1,4.034.746l-1.089,5.668A26.222,26.222,0,0,0,49.121,39.687a2.017,2.017,0,1,1,3.853,1.19,30.256,30.256,0,0,1-24.145,21.3Z",
  transform: "translate(9.536 22.736)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_346",
  "data-name": "Rechteck 346",
  width: 19.122,
  height: 4.034,
  transform: "translate(1.064 83.499) rotate(-45)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_347",
  "data-name": "Rechteck 347",
  width: 12.849,
  height: 4.034,
  transform: "translate(0 72.739) rotate(-45)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_348",
  "data-name": "Rechteck 348",
  width: 12.849,
  height: 4.034,
  transform: "translate(11.815 84.579) rotate(-45)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_1120",
  "data-name": "Pfad 1120",
  d: "M40.584,38.683a9.6,9.6,0,1,1,6.777-2.8h0A9.46,9.46,0,0,1,40.584,38.683Zm0-15.148a5.567,5.567,0,0,0-4.034,9.5,5.708,5.708,0,0,0,7.867,0h0a5.567,5.567,0,0,0-3.933-9.5Z",
  transform: "translate(14.019 3.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_1121",
  "data-name": "Pfad 1121",
  d: "M59.116,36.742a2.017,2.017,0,0,1-1.815-1.13A44.88,44.88,0,0,0,37.332,15.159a2.025,2.025,0,0,1,1.836-3.611A49.036,49.036,0,0,1,60.932,33.857a2.005,2.005,0,0,1-1.815,2.884Z",
  transform: "translate(19.369 -4.596)"
})));

var SvgIntroExplore = function SvgIntroExplore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143.879,
    height: 115.335,
    viewBox: "0 0 143.879 115.335",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIntroExplore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/intro_explore.088dc433.svg";
export { ForwardRef as ReactComponent };